<template>
    <div class="row">
        <div class="col-md-12 position-relative">
            <textarea
                class="form-control"
                placeholder="Enter Message"
                v-model="smsData.description"
                rows="5"
            ></textarea>
            <div class="text-danger" v-if="errors.sms_description">
                {{ errors.sms_description[0] }}
            </div>
        </div>

        <!-- <div class="col-md-6 position-relative">
            <h6  class="mb-3">Templates</h6>
            <div class="template-buttons position-absolute top-0 end-0">
                <button
                    class="btn btn-outline-primary btn-sm me-2"
                    @click="toggleTemplateView('favorites')"
                    :class="{ active: templateView === 'favorites' }"
                >
                    Favorites
                </button>
                <button
                    class="btn btn-outline-primary btn-sm"
                    @click="toggleTemplateView('all')"
                    :class="{ active: templateView === 'all' }"
                >
                    All
                </button>
            </div>
            <p v-if="templateView === 'all' && templates.length === 0">
                No template available!
            </p>
        </div> -->
        <div class="col-md-12 mt-3">
            <div class="d-flex justify-content-end">
                <button class="btn btn-success" @click="saveSMS">
                    <span v-if="!isLoading">Send SMS</span>
                    <span v-else>Loading...</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/utils/http";

export default {
    props: {
        leadId: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        isLoading: false,
        
        templateView: "all",
        templates: [],

        smsData: {
            description: ''
        },
        
        errors: {},
      };
    },
    mounted() {
            const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath=lastPart;
    },
    methods: {
        
        toggleTemplateView(view) {
            this.templateView = view;
        },

        async saveSMS() {
            this.isLoading = true
            const endpoint = "/store-leads-details-sms-info";
            const method = "post";
            let body = {
                lead_id: this.leadId,
                sms_description: this.smsData.description,
                key_account: this.currentPath == 'key-account-details' ? 'Y':'N'
            };
            try {
                const response = await http[method](endpoint, body);
                this.$emitter.emit("form-submitted");
                this.$toast.success(response.data.message);
                this.errors = {}
                this.isLoading= false
                this.smsData = {
                    description: ''
                }
            } catch (error) {
                this.isLoading= false
                this.errors = error.response.data.errors;
            } finally {
            this.isLoading = false;
            }
        },
    },
};
</script>